import { pickBy } from 'lodash'

export function filterDataAttr(attrObj) {
    return pickBy(attrObj, (value, key) => key.includes('data-'))
}
